import React from 'react';
import { Icon } from '@frontend/icons';
import { styles } from '../../../styles';
import { Text } from '../../text';
import { ActionPressedChip } from '../atoms';

type StrikethroughActionProps = Omit<React.ComponentProps<typeof ActionPressedChip>, 'children'>;

export const StrikethroughAction = ({ compact = true, showBoxShadow = true, ...rest }: StrikethroughActionProps) => {
  return (
    <ActionPressedChip {...rest} compact={compact} showBoxShadow={showBoxShadow}>
      <Text as='strong' weight='bold' css={styles.flexCenter}>
        <Icon name='strikethrough-small' />
      </Text>
    </ActionPressedChip>
  );
};
